export class GalleryClass {
  type!: string;
  src!: string;
  date!: string;
  data!: string;
}

export const GalleryData: GalleryClass[] = [
  {
    type: "vid",
    src: "https://www.youtube.com/watch?v=7ZR6ME8SaH0",
    date: "date",
    data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  },
  {
    type: "vid",
    src: "https://www.youtube.com/watch?v=7ZR6ME8SaH0",
    date: "date",
    data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  },
  {
    type: "img",
    src: "https://www.google.com/imgres?imgurl=https%3A%2F%2Fimages.pexels.com%2Fphotos%2F268533%2Fpexels-photo-268533.jpeg%3Fcs%3Dsrgb%26dl%3Dpexels-pixabay-268533.jpg%26fm%3Djpg&imgrefurl=https%3A%2F%2Fwww.pexels.com%2Fsearch%2Fbeautiful%2F&tbnid=nwiTKnJXTwcwcM&vet=12ahUKEwi-uZHg2vP8AhXXmicCHRXYBw0QMygBegUIARDfAQ..i&docid=B51x0PBR9KNzvM&w=1920&h=1278&q=images&ved=2ahUKEwi-uZHg2vP8AhXXmicCHRXYBw0QMygBegUIARDfAQ",
    date: "date",
    data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  },
  {
    type: "img",
    src: "https://www.google.com/imgres?imgurl=https%3A%2F%2Fimages.pexels.com%2Fphotos%2F268533%2Fpexels-photo-268533.jpeg%3Fcs%3Dsrgb%26dl%3Dpexels-pixabay-268533.jpg%26fm%3Djpg&imgrefurl=https%3A%2F%2Fwww.pexels.com%2Fsearch%2Fbeautiful%2F&tbnid=nwiTKnJXTwcwcM&vet=12ahUKEwi-uZHg2vP8AhXXmicCHRXYBw0QMygBegUIARDfAQ..i&docid=B51x0PBR9KNzvM&w=1920&h=1278&q=images&ved=2ahUKEwi-uZHg2vP8AhXXmicCHRXYBw0QMygBegUIARDfAQ",
    date: "date",
    data: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia, molestiae quas",
  },
];
